/**
 * program
 * Program APIs
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import { CapacitorHttp } from '@capacitor/core';
import { HttpParameterCodec, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { CustomHttpParameterCodec } from '../encoder';
import Session from 'supertokens-web-js/recipe/session';
import { AuthStrategy } from '@libs/services/auth-strategy';

// @ts-ignore
import { CreateWeightLossCheckInAppointmentDto } from '../model/createWeightLossCheckInAppointmentDto';
// @ts-ignore
import { GetWeightLossDataDto } from '../model/getWeightLossDataDto';
// @ts-ignore
import { WeightLossCheckinDataDto } from '../model/weightLossCheckinDataDto';
// @ts-ignore
import { WeightLossProgramExternalAppointmentDto } from '../model/weightLossProgramExternalAppointmentDto';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration } from '../configuration';

@Injectable({
  providedIn: 'root'
})
export class WeightLossProgramCheckInService {
  protected basePath = 'http://localhost';
  public defaultHeaders: any = {};
  public configuration = new Configuration();
  public encoder: HttpParameterCodec;

  constructor(
    @Optional()@Inject(BASE_PATH) basePath: string|string[],
    @Optional() configuration: Configuration,
    @Optional() private readonly authStrategy: AuthStrategy, // Inject the strategy if provided
  ) {
    if (configuration) {
      this.configuration = configuration;
    }
    if (typeof this.configuration.basePath !== 'string') {
      if (Array.isArray(basePath) && basePath.length > 0) {
        basePath = basePath[0];
      }

      if (typeof basePath !== 'string') {
        basePath = this.basePath;
      }
      this.configuration.basePath = basePath;
    }
    this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
  }


  /**
   * @param xTENANTID 
   * @param createWeightLossCheckInAppointmentDto 
   */
  public async programWeightLossCheckInControllerCreateCheckInAppointment(xTENANTID: string, createWeightLossCheckInAppointmentDto: CreateWeightLossCheckInAppointmentDto, ): Promise<WeightLossProgramExternalAppointmentDto> {
    if (xTENANTID === null || xTENANTID === undefined) {
      throw new Error('Required parameter xTENANTID was null or undefined when calling programWeightLossCheckInControllerCreateCheckInAppointment.');
    }
    if (createWeightLossCheckInAppointmentDto === null || createWeightLossCheckInAppointmentDto === undefined) {
      throw new Error('Required parameter createWeightLossCheckInAppointmentDto was null or undefined when calling programWeightLossCheckInControllerCreateCheckInAppointment.');
    }

    const localVarHeaders = this.defaultHeaders;
    if (xTENANTID) {
      localVarHeaders['X-TENANT-ID'] = String(xTENANTID);
    }

    const token = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${token}`;
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const response = await CapacitorHttp.post({
      url: `${this.configuration.basePath}/api/program/programs/weight-loss/create-check-in-appointment`,
        data: createWeightLossCheckInAppointmentDto,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
  /**
   * @param xTENANTID 
   * @param getWeightLossDataDto 
   */
  public async programWeightLossCheckInControllerGetCheckinData(xTENANTID: string, getWeightLossDataDto: GetWeightLossDataDto, ): Promise<WeightLossCheckinDataDto> {
    if (xTENANTID === null || xTENANTID === undefined) {
      throw new Error('Required parameter xTENANTID was null or undefined when calling programWeightLossCheckInControllerGetCheckinData.');
    }
    if (getWeightLossDataDto === null || getWeightLossDataDto === undefined) {
      throw new Error('Required parameter getWeightLossDataDto was null or undefined when calling programWeightLossCheckInControllerGetCheckinData.');
    }

    const localVarHeaders = this.defaultHeaders;
    if (xTENANTID) {
      localVarHeaders['X-TENANT-ID'] = String(xTENANTID);
    }

    const token = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${token}`;
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const response = await CapacitorHttp.post({
      url: `${this.configuration.basePath}/api/program/programs/weight-loss/get-checkin-data`,
        data: getWeightLossDataDto,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
}
